<template>
  <div v-if="error && !violations" class="fill-height">
    <GenericError />
  </div>
  <div v-else>
    <template v-if="isLoading">
      <div class="content-spinner">
        <v-progress-circular indeterminate size="75" color="primary"></v-progress-circular>
      </div>
    </template>
    <template v-else>
      <UserForm :handle-submit="onSendForm" :handle-update-field="updateField" :values="item" :errors="violations" />
    </template>
  </div>
</template>

<script>
import GenericError from '@/components/error/GenericError'
import { createNamespacedHelpers } from 'vuex'
import UserForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('user/create')

export default {
  components: {
    GenericError,
    UserForm
  },

  data() {
    return {
      item: {}
    }
  },

  computed: mapGetters(['error', 'isLoading', 'created', 'violations']),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function(created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'UserList' })
    }
  },

  methods: {
    ...mapActions(['create']),

    onSendForm() {
      this.create(this.item)
    },

    updateField(field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
